import TopCitiesDefault from "./TopCitiesDefault/TopCitiesDefault";
import TopCitiesAffinityCarousel from "./TopCitiesAffinityCarousel/TopCitiesAffinityCarousel";
import TopCitiesDestinationDiscovery from "./TopCitiesDestinationDiscovery/TopCitiesDestinationDiscovery";
import TopCitiesDestination from "./TopCitiesDestination/TopCitiesDestination";

export const topCitiesView = {
  default: TopCitiesDefault,
  "affinity-carousel": TopCitiesAffinityCarousel,
  "destination-discovery": TopCitiesDestinationDiscovery,
  "full-bleed-image": TopCitiesDestination,
  "image-top-card": TopCitiesDestination,
  "image-left-card": TopCitiesDestination,
};
